<div class="course-details">
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div class="intro">
    <h2 class="mat-display-2">Details zum Projekt</h2>
  </div>
  <div class="details" *ngIf="project !== undefined">
    <div class="main_detail">
      <div class="info_proj">
        <a routerLink="/projects" class="list">Zu den Projekten</a>
        <a *ngIf="isAdmin()" routerLink="/projects/list" class="list">Zurück zur Projektliste</a>
      </div>
      <div class="titleLogo">

        <div class="logo_proj" *ngIf="project.project_icon_url?.trim()">
          <div>
            <img alt="AltImage.ai" [src]="project.project_icon_url">
          </div>
        </div>

        <div>
          <mat-card-title>{{ project.title }}</mat-card-title>
        </div>
      </div>

      <div class="proj_date">
        Wann: {{ project.start_date | date }} - {{ project.end_date | date }}
      </div>

      <div class="proj_date">Wo: {{ project.location }}</div>

      <div class="img_proj" *ngIf="project.project_image_url && project.project_image_url !== '' && project.project_image_url !== image">
        <div>
          <img [src]="project.project_image_url" alt="" />
        </div>
      </div>
      <div class="desc_proj">
        <div [innerHTML]="project.content" class="preview-content"></div>
      </div>
      <div *ngIf="validSponsorImages && validSponsorImages.length > 0" class="partners-img"
        style="width: 100%;">
        <h1>gefördert von :</h1>
        <div class="carousel-container">
          <img class="carousel" *ngFor="let imageUrl of validSponsorImages" [src]="imageUrl" alt="" />
        </div>
      </div>
      <div *ngIf="validPartnerImages && validPartnerImages.length > 0" class="partners-img">
        <h1>Kooperationspartner</h1>
        <div  class="carousel-container">
          <img class="carousel" *ngFor="let imageUrl of validPartnerImages" [src]="imageUrl" alt="" />
        </div>
      </div>
      <mat-card-actions align="end" *ngIf="isAdmin()">
        <button mat-button (click)="editProject()">Bearbeiten</button>
        <button mat-button (click)="deleteProject(project)">Löschen</button>
      </mat-card-actions>
    </div>
  </div>
</div>
